import React, { useEffect, useState } from 'react';
import { Link, useLocation  } from 'react-router-dom';
import { useAdminMenu } from '../context/AdminMenuContext';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import logo from '../assets/logo.svg';
import settingIcon from '../assets/setting.svg';
import SessionExpireModal from './common/SessionExpireModal';
import '../styles/Header.scss';

const Header: React.FC = () => {
  const token = localStorage.getItem('token');
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { pathname } = useLocation();          
  const isAdmin = pathname.startsWith("/admin");
  const { isMobileMenuOpen, toggleMobileMenu } = useAdminMenu(); 

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';    
  };

  useEffect(() => {
    if (!token) return;

    try {
      const decoded: any = jwtDecode(token);
      const expTime = moment.unix(decoded.exp); 

      const updateTimer = () => {
        const now = moment();
        const diffSeconds = expTime.diff(now, 'seconds');
        
        setTimeLeft(Math.max(0, diffSeconds));

        if (diffSeconds <= 0) {
          clearInterval(timer); 
          setIsModalOpen(true);
        }
      };

      updateTimer(); // 초기 실행
      const timer = setInterval(updateTimer, 1000);

      return () => clearInterval(timer);
    } catch (error) {
      console.error('Invalid token:', error);
      handleLogout();
    }
  }, [token]);

  return (
    <header className={`header ${isAdmin ? "admin-header" : ""}`}>
      <div className="header__container">

        <Link to={isAdmin ? "/admin" : "/"} className="header__logo">
          <img src={logo} alt="RE:BORN TALK" />
        </Link>

        <div className="flex gap-8">
          {token && (
            <div className="header__actions">
              <p className="session-time">
                세션 종료 {timeLeft !== null ? moment.utc(timeLeft * 1000).format('mm:ss') : '--:--'}</p>
              <Link to="/setting" className="header__setting-icon">
                <img src={settingIcon} alt="Settings" />
                <span>설정</span>
              </Link>
              <button className="logout-button" onClick={handleLogout}>
                로그아웃
              </button>
            </div>          
          )}
          {isAdmin && (
            <button 
              className="admin-hamburger-btn"
              onClick={toggleMobileMenu}
              aria-label="메뉴 열기/닫기"
            >
                {isMobileMenuOpen ? (
                  <div className="admin-hamburger-btn-open"></div>
                ) : (
                  <div className="admin-hamburger-btn-close"></div>
                )}
            </button>
          )}     
        </div>        
      </div>
      <SessionExpireModal isOpen={isModalOpen} onConfirm={handleLogout} />
    </header>
  );
};

export default Header;
